import * as React from "react";
import PropTypes from "prop-types";

import "./styles.css";
import useAsyncEffect from "@n1ru4l/use-async-effect";
import { formatPrice, _ } from "../../model/utils";

const SidePrice = ({
  computePrice,
  price,
  numNights,
  extraContainerStyleName,
  hidePriceInLowRes
}) => {
  const [loading, setLoading] = React.useState(false);
  const [value, setValue] = React.useState(null);

  const stopLoading = React.useCallback(() => setLoading(false), []);

  useAsyncEffect(
    function*(onCancel) {
      onCancel(stopLoading, stopLoading);
      setLoading(true);
      const myPrice = computePrice ? yield computePrice() : price;
      setValue(myPrice);
      stopLoading();
    },
    [computePrice, price, stopLoading]
  );

  return (
    value !== null && (
      <div
        styleName={
          "container" +
          (extraContainerStyleName ? " " + extraContainerStyleName : "")
        }
      >
        {loading ? (
          <div styleName="loading">Loading...</div>
        ) : (
          <>
            {numNights !== undefined && numNights !== null && (
              <span styleName="num-nights">
                {(_.numNights || "{0} nights").replace("{0}", numNights)}
              </span>
            )}
            <span
              styleName={
                "label" + (hidePriceInLowRes ? " hide-price-in-low-res" : "")
              }
              className={hidePriceInLowRes ? "d-none d-sm-inline" : ""}
            >
              {_.price}:
            </span>
            <span styleName="value">{formatPrice(value)}€</span>
          </>
        )}
      </div>
    )
  );
};

SidePrice.propTypes = {
  computePrice: PropTypes.func,
  price: PropTypes.number,
  numNights: PropTypes.number,
  extraContainerStyleName: PropTypes.string,
  hidePriceInLowRes: PropTypes.bool
};

export default SidePrice;
